import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getBatchesByLocation, getBatchesByEntity } from '../../../../../actions/inventoryActions'
import BatchesLocationsListView from '../../../../containers/Inventory/InventoryLocations/BatchesLocationsList/BatchesLocationsList'
import { useHistory } from "react-router-dom";


/**
 * [BatchesLocationsList: component to get the batches in inventory 
 * filtered by locationId and productId of an Entity or Location]
 * @param  match  inventoryType and id
 * @return string  With format time
 */


const BatchesLocationsList = ({ match }) => {

  let auxFunction;
  const history = useHistory();

  let inventoryType = match.params.inventoryType;
  let productId = match.params.productId;
  let locationId = match.params.locationId;
  let locationName = match.params.locationName;
  
  const dispatch = useDispatch();
  const { batchesByLocation } = useSelector(state => state.inventory);
  useEffect(() => {
      batchesByLocation.length=0;
      switch(inventoryType){
        case 'Location':
          auxFunction = dispatch(getBatchesByLocation(productId, locationId));
          break;

        case 'Entity':
          auxFunction = dispatch(getBatchesByEntity(locationId, productId));
          break;

        default:
          console.log()
    }

    return () => { }
    }, []);
try{
    console.log();
    console.log();
    console.log();
    console.log();
    console.log();
   }
   catch (e) {} 



  return (
    <BatchesLocationsListView
      inventoryProducts={batchesByLocation.batches}
      inventoryType={inventoryType}
      locationName={locationName}
    />
  )
}

export default BatchesLocationsList